import { FormattedMessage } from 'react-intl';
import { PhoneNumberFormat, PhoneNumberUtil } from 'google-libphonenumber';

import {
    type ContactPerson as ContactPersonApi,
    type PhoneNumber as PhoneNumberApi,
    PhoneType,
} from '@/generated/GeneratedApiTypes';

interface ContactPersonProps {
    contactPerson: ContactPersonApi;
}

const COLON = ': ';

const getFormattedPhoneNumber = (phoneNumber: string): string => {
    try {
        const phoneUtil = PhoneNumberUtil.getInstance();
        const parsed = phoneUtil.parse(phoneNumber, '');
        return phoneUtil.format(parsed, PhoneNumberFormat.INTERNATIONAL);
    } catch {
        return phoneNumber;
    }
};

const sortLandLineFirst = (phoneA: PhoneNumberApi, phoneB: PhoneNumberApi): number => {
    if (phoneA.type === phoneB.type) {
        return 0;
    }
    return phoneA.type === PhoneType.PHONE_TYPE_LAND_LINE ? -1 : 1;
};

const PhoneNumberElement = ({ phone }: { phone: PhoneNumberApi }) => (
    <div>
        <FormattedMessage id={`intl-msg:engineOil.table.customerDetails.phone-type.${phone.type}`} />
        {COLON}
        {getFormattedPhoneNumber(phone.number)}
    </div>
);

const PhoneNumbers = ({ phoneNumbers }: { phoneNumbers: PhoneNumberApi[] }) => {
    if (phoneNumbers.length === 0) {
        // eslint-disable-next-line id-denylist
        return <PhoneNumberElement phone={{ type: PhoneType.PHONE_TYPE_LAND_LINE, number: '-' }} />;
    }
    return (
        <>
            {phoneNumbers
                .slice()
                .sort(sortLandLineFirst)
                .map((phone) => (
                    <PhoneNumberElement key={`${phone.type}-${phone.number}`} phone={phone} />
                ))}
        </>
    );
};

const ContactPerson = ({ contactPerson }: ContactPersonProps) => {
    const { name, email, phone_numbers: phoneNumbers } = contactPerson;

    return (
        <>
            <div className="text-color-gray margin-top-10">
                <FormattedMessage id="intl-msg:engineOil.table.customerDetails.contactPerson" />
            </div>
            <div>{name}</div>
            <div>
                <FormattedMessage id="intl-msg:engineOil.table.customerDetails.email" />
                {COLON}
                {email ? <a href={`mailto:${email}`}>{email}</a> : '-'}
            </div>
            <PhoneNumbers phoneNumbers={phoneNumbers} />
        </>
    );
};

export default ContactPerson;
